import { motion } from "framer-motion";
import {
  Flame,
  FlaskConical,
  Zap,
  Plane,
  Car,
  Shield,
  TrainFront,
  PlugZap,
  Mountain,
} from "lucide-react";

const INDUSTRIES = [
  { icon: Flame, name: "Oil & Gas" },
  { icon: FlaskConical, name: "Chemical" },
  { icon: Zap, name: "Power Generation" },
  { icon: Plane, name: "Aerospace" },
  { icon: Car, name: "Automotive" },
  { icon: Shield, name: "Defence" },
  { icon: TrainFront, name: "Railway" },
  { icon: PlugZap, name: "Electrical" },
  { icon: Mountain, name: "Mining & Allied" },
];

export default function Industries() {
  return (
    <section id="industries" className="bg-white py-20 lg:py-24" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 lg:mb-14"
        >
          <div>
            <div className="flex items-center gap-3 font-sans font-medium text-[11px] sm:text-xs tracking-[0.12em] uppercase text-steel font-semibold mb-4">
              <span className="w-10 h-[2px] bg-brand" />
              Industries We Serve
            </div>
            <h2 className="font-display font-extrabold uppercase tracking-tight leading-[1.02] text-4xl sm:text-5xl text-ink">
              Fasteners for every
              <br />
              heavy industry
            </h2>
          </div>
          <p className="max-w-sm text-sm text-slate-600 leading-relaxed">
            Our fasteners are manufactured to meet the varied needs of these
            industries — designed and developed to the specifications of every
            client.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {INDUSTRIES.map((it, i) => {
            const Icon = it.icon;
            const slug = it.name.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "");
            return (
              <motion.div
                key={it.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                onMouseMove={(e) => {
                  const r = e.currentTarget.getBoundingClientRect();
                  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
                }}
                whileHover={{ y: -4 }}
                className="spotlight-card group relative overflow-hidden flex items-center gap-3 sm:gap-4 rounded-xl border border-steel-light bg-white px-4 sm:px-5 py-4 sm:py-5 shadow-sm hover:shadow-lg hover:border-brand transition-all duration-300"
                data-testid={`industry-${slug}`}
              >
                <span className="shrink-0 w-10 h-10 rounded-md bg-navy-deep text-white flex items-center justify-center group-hover:bg-brand transition-all duration-500 group-hover:shadow-[0_6px_18px_rgba(27,95,170,0.28)]">
                  <Icon size={17} />
                </span>
                <span className="relative font-display font-bold uppercase text-sm sm:text-base lg:text-lg text-ink leading-tight transition-colors duration-300 group-hover:text-brand">
                  {it.name}
                  <span className="absolute -bottom-1 left-0 h-px w-0 bg-brand transition-all duration-500 group-hover:w-full" />
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
